import { useLastPathSegment } from 'shared/hooks'
import { useTextEnableLandlineContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineContext'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useTextEnableLandlineContext()

  return getProgressInfoTitle(useLastPathSegment())
}
